export default [
  {
    title: 'Catalog',
    section: 'store',
    order: 2,
    icon: 'library_books',
    items: [
      {
        title: 'Products',
        component: 'products',
        section: 'store'
      },
      {
        title: 'Taxonomy',
        component: 'taxonomy',
        section: 'store'
      },
      {
        title: 'Manage Inventory',
        component: 'inventory',
        section: 'store'
      }
    ]
  }
]
